import { Card } from "@mui/material";
import { BarChartOutlined } from "@mui/icons-material";
import { useDomesticMarketMonthlyStockSalesContext } from "../../../context/domestic-market/monthly-stock-sales/DomesticMarketMonthlyStockSalesContext";
import { sendData } from "../../../lib/dashboard/actions";
import useResponsive from "../../../components/hooks/useResponsive";
import { mutate } from "swr";
import AddToFavoritesButton from "../../../components/favorite/AddToFavoritesButton";
import Grid2 from "@mui/material/Unstable_Grid2";
import { CustomAutocomplete } from "../../../components/custom/CustomAutocomplete";
import Loading from "../../../components/loader/Loading";
import { COLORS } from "../../../ui/Theme";

const DomesticMarketMonthlyStockSalesForm = () => {
  const {
    companies,
    selectedCompany,
    setSelectedCompany,
    handleShowChart,
    isChartLoading,
    isFavoritesValidation,
  } = useDomesticMarketMonthlyStockSalesContext();

  const { isLg } = useResponsive();

  const body = { company_id: selectedCompany?.id };

  const handleAddToFavorite = async () => {
    const { status } = await sendData(body, "/favorite/domestic-production");
    if (status === 200) await mutate("/favorite/domestic-production");
  };

  const isDisabled = [isChartLoading, !selectedCompany].some(Boolean);

  return (
    <Card>
      <Grid2 container spacing={1} aligns={"center"}>
        {isLg && (
          <Grid2 xs={12} md={6} lg={0.5}>
            <AddToFavoritesButton
              style={{ height: "44px" }}
              isDisabled={isDisabled}
              onClick={handleAddToFavorite}
              isLoading={isFavoritesValidation}
            />
          </Grid2>
        )}
        <Grid2 xs={12} md={6} lg={2.5}>
          <CustomAutocomplete
            isLoading={companies.isLoading}
            onChange={(e, newValue) => setSelectedCompany(newValue)}
            options={companies?.data || []}
            placeholder="شرکت"
            value={selectedCompany}
          />
        </Grid2>
        <Grid2 xs={10} lg={1}>
          <button
            style={{ height: "43px" }}
            onClick={() => handleShowChart(body)}
            className={`btn ${!selectedCompany ? " btn-softblue" : "btn-blue"}`}
            disabled={isDisabled || isChartLoading}
          >
            {isChartLoading ? (
              <Loading color={COLORS.WHITE} />
            ) : (
              <>
                نمایش
                <BarChartOutlined />
              </>
            )}
          </button>
        </Grid2>
        {!isLg && (
          <Grid2 xs={2}>
            <AddToFavoritesButton
              onClick={handleAddToFavorite}
              isDisabled={isDisabled}
              style={{ height: "43px" }}
              isLoading={isFavoritesValidation}
            />
          </Grid2>
        )}
      </Grid2>
    </Card>
  );
};

export default DomesticMarketMonthlyStockSalesForm;
